/**
 * The dot on the changelog bell.
 *
 * Whether there is news is a question about the reader, and the server knows
 * nothing about them: no account is required to read this site, and the ones
 * who most need the answer — somebody deciding whether to trust the bot — are
 * exactly the ones who have never signed in. So the comparison happens in the
 * browser, between the newest entry's name and the last one this browser
 * opened.
 *
 * Storage can throw rather than return nothing: a private window, a browser set
 * to refuse site data, a page opened in a preview. Every read and write is
 * guarded, and a failure leaves the bell quiet — a dot that can never be
 * cleared is worse than no dot at all.
 */

const KEY = 'bilbi:changelog-seen';

function remembered(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

function remember(slug: string): void {
  try {
    localStorage.setItem(KEY, slug);
  } catch {
    // Nothing to do: the dot simply comes back next time.
  }
}

export function initChangelogBell(): void {
  const bell = document.querySelector<HTMLElement>('[data-changelog-bell]');
  if (!bell) return;

  const latest = bell.dataset.latest ?? '';
  if (!latest) return;

  /*
   * Reading the page marks it read, whichever entry brought them here. The
   * whole list is on one page, so opening it *is* having seen the newest.
   */
  if (document.querySelector('[data-changelog-page]')) {
    remember(latest);
    return;
  }

  if (remembered() === latest) return;

  const dot = bell.querySelector<HTMLElement>('[data-changelog-dot]');
  dot?.classList.remove('hidden');
}
